// @flow
import * as React from 'react';

type State = {
  component?: React.Node,
  props: any,
  showModal: (component: React.Node, props: any) => void,
  hideModal: () => void
};

const ModalContext = React.createContext<State>({
  component: null,
  props: {},
  showModal: (component: React.Node, props: any) => {},
  hideModal: () => {}
});

class ModalProvider extends React.Component<{ children: React.Node }, State> {
  showModal = (component: React.Node, props: any = {}) => {
    this.setState({
      component,
      props
    });
  };

  hideModal = () =>
      this.setState({
        component: null,
        props: {}
      });

  state = {
    component: null,
    props: {},
    showModal: this.showModal,
    hideModal: this.hideModal
  };

  render() {
    return (
        <ModalContext.Provider value={this.state}>
          {this.props.children}
        </ModalContext.Provider>
    );
  }
}

const ModalConsumer = ModalContext.Consumer;
export { ModalProvider, ModalConsumer, ModalContext };
